/**
 * Structured diagnostics: PU login → client.init → OTP WS → MobX authorize → symbols/chart.
 *
 * Verbose OK-path: localStorage.debug_everyman_pipeline = '1'
 * Fail always surfaces via console.error / console.warn with prefix [everyman-pipeline]
 */

export function isEverymanPipelineTraceEnabled() {
    try {
        return (
            typeof localStorage !== 'undefined' && localStorage.getItem('debug_everyman_pipeline') === '1'
        );
    } catch {
        return false;
    }
}

export function everymanLoginidSafe(loginid) {
    if (typeof loginid !== 'string' || !loginid) {
        return { prefix: '', len: 0 };
    }
    return { prefix: loginid.slice(0, 3), len: loginid.length };
}

/** Non-secret counts / oauth markers for debugging blocked flows */
export function everymanAuthSnapshot(extra = {}) {
    try {
        const ls = typeof localStorage !== 'undefined' ? localStorage : null;
        const oauth_token_len = ls ? (ls.getItem('oauth2_access_token') || '').length : 0;
        const deriv_app_raw = ls
            ? ls.getItem('botblitz_sync_oauth_deriv_app_id') || ls.getItem('config.app_id') || ''
            : '';
        const accounts_raw = ls ? ls.getItem('client.accounts') || '{}' : '{}';
        let client_accounts_keys = 0;
        try {
            const o = JSON.parse(accounts_raw);
            client_accounts_keys = typeof o === 'object' && o !== null ? Object.keys(o).length : 0;
        } catch {
            client_accounts_keys = -1;
        }
        return {
            auth_flow: ls ? ls.getItem('auth_flow') || '' : '',
            oauth2_token_len: oauth_token_len,
            deriv_app_id_len: String(deriv_app_raw).trim().length,
            client_accounts_keys,
            ...extra,
        };
    } catch {
        return { auth_flow: 'snapshot_error', ...extra };
    }
}

function serializeErr(err) {
    if (err == null) return undefined;
    if (err instanceof Error) {
        return {
            name: err.name,
            message: err.message,
            stack:
                typeof err.stack === 'string'
                    ? err.stack
                          .split('\n')
                          .slice(0, 12)
                          .join('\n')
                    : undefined,
        };
    }
    return String(err);
}

/** Hard failure — always logged */
export function everymanPipelineFail(stage, message, err, extra = {}) {
    console.error('[everyman-pipeline] FAIL', {
        stage,
        message,
        error: serializeErr(err),
        ...everymanAuthSnapshot(extra),
    });
}

/** Recoverable / incomplete — always logged */
export function everymanPipelineWarn(stage, message, extra = {}) {
    console.warn('[everyman-pipeline] WARN', {
        stage,
        message,
        ...everymanAuthSnapshot(extra),
    });
}

/** Success milestone — only when trace enabled */
export function everymanPipelineOk(stage, message, extra = {}) {
    if (!isEverymanPipelineTraceEnabled()) return;
    console.info('[everyman-pipeline] OK', {
        stage,
        message,
        ...everymanAuthSnapshot(extra),
    });
}
